import { cx } from "../../utils";

/**
 * One-click links to the app page's own tabs, for an announcement or
 * notification button. The app page opens these in place ("#support") rather
 * than in a new tab. Keep in step with TAB_LINKS in backend _utils/safeLink.js.
 */
export const APP_TABS = [
  { link: "#get-started", label: "Get started", button: "Finish setup" },
  { link: "#credentials", label: "Credentials", button: "Update credentials" },
  { link: "#usage", label: "How to use", button: "See how to use it" },
  { link: "#feature-requests", label: "Feature requests", button: "Request a feature" },
  { link: "#support", label: "Support", button: "Contact support" },
];

/** Picking a tab also fills the button text when it's still empty. */
const TabLinks = ({ value, label, onPick }) => (
  <div className="mt-2 flex flex-wrap items-center gap-1.5">
    <span className="text-[11.5px] text-ink-400">Or link a tab:</span>
    {APP_TABS.map((t) => (
      <button
        key={t.link}
        type="button"
        onClick={() => onPick({ linkUrl: t.link, linkLabel: label?.trim() ? label : t.button })}
        className={cx(
          "rounded-full px-2.5 py-0.5 text-[11.5px] font-medium ring-1 transition-colors",
          value === t.link
            ? "bg-brand-600 text-white ring-brand-600"
            : "bg-white text-ink-600 ring-ink-200 hover:bg-ink-50 hover:text-ink-900",
        )}
      >
        {t.label}
      </button>
    ))}
  </div>
);

export default TabLinks;
